<script setup lang="ts">
    import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { useEmployeeData } from '@/composables/useEmployeeData';
    import { computed } from 'vue';

    const { employeesAndGroups } = useEmployeeData();

    const employeeOptions = computed(() => {
        return employeesAndGroups.value.keepers || [];
    });

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="grid gap-3 sm:grid-cols-1">
        <InputRow
            :form="form"
            name="name"
            label="user-groups.form.labels.name"
        >
            <Input
                id="name"
                v-model="form.name"
                autocomplete="name"
                :placeholder="$t('user-groups.form.labels.name')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="user_ids"
            label="user-groups.form.labels.users"
        >
            <MultiCombobox
                v-model="form.user_ids"
                :options="employeeOptions"
                :placeholder="$t('user-groups.form.labels.users')"
                label-by="name"
                value-by="id"
            />
        </InputRow>
    </div>
</template>
